// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/tcas-acas.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/tcas-acas/tcas-acas.js';

mount([g0]);
